module.exports = __webpack_public_path__ + "static/media/iconfont.da3a73d5.svg";